export interface Jumpbox {
  name?: string;
  dataZone?: string;
  expiresAt?: string;
  status?: string;
  createdAt?: string;
  modifiedAt?: string;
  createdBy?: string;
  modifiedBy?: string;
}


export interface JumpboxResponse {
  data: Jumpbox[];
  metadata: {
    filteredAt: string;
    totalRecords: number;
    filterCriteria?: {
      status: string;
      timeWindow: string;
    };
    error?: string;
  };
}


export enum JumpboxTypes {
  COMPLETED = 'completed',
  INPROGRESS = 'inprogress',
  FAILED = 'failed',
  DELETING = 'deleting',
  DELETED = 'deleted',
  DELETION_FAILED = 'deletion_failed'
}